<template>
  <v-layout align-center>
    <v-layout
      v-if="visible"
      align-center
    >
      <v-flex
        shrink
        py-1
        @click="checkDuplicateInPreviousEdition"
      >
        <a
          class="fw-600 mb-0 display-2_dark"
          :class="checkPreviousEditionsLoader ? 'disabled' : ''"
        >
          {{ $t('family_card.enteranse.check_p_e') }}
        </a>
      </v-flex>
      <v-flex
        v-if="checkPreviousEditionsLoader"
        shrink
        ml-2
      >
        <v-progress-circular
          indeterminate
          color="primary"
        />
      </v-flex>
    </v-layout>
    <AppModal
      :visible="responseModal"
      :close-button="false"
      persistent
    >
      <template slot="content">
        <p class="f-1 mb-0">
          {{ similarFamilyModalText }}
        </p>
      </template>
      <template slot="actions">
        <v-layout
          align-center
          class="my-2"
          justify-end
        >
          <v-btn
            color="sz_violet"
            :disabled="confirmButtonLoader"
            :loading="confirmButtonLoader"
            @click="closeResponseModal()"
          >
            {{ $t('buttons.ok') }}
          </v-btn>
        </v-layout>
      </template>
    </AppModal>
    <AppModal
      :visible="isGluedModal"
      :close-button="false"
      persistent
    >
      <template slot="content">
        <v-layout
          align-center
          mt-3
        >
          <v-flex
            shrink
            pa-2
            pl-0
          >
            <v-icon color="sz_red">
              warning
            </v-icon>
          </v-flex>
          <v-flex
            shrink
            pa-2
            pr-0
          >
            <h2 class="text-xs-left f-16 sz_grafit--text ma-0 mt-1 font-weight-regular">
              {{ $t('alikes_families.p_e.glued_warning.title') }}
            </h2>
            <h2 class="text-xs-left f-16 sz_grafit--text ma-0 mt-2 font-weight-regular">
              {{ $t('alikes_families.p_e.glued_warning.text') }}
            </h2>
          </v-flex>
        </v-layout>
      </template>
      <template slot="actions">
        <v-layout
          align-center
          class="my-2"
          justify-end
        >
          <v-btn
            color="sz_violet"
            @click="closeGluedModal()"
          >
            {{ $t('buttons.ok') }}
          </v-btn>
        </v-layout>
      </template>
    </AppModal>
    <AppModal
      :visible="showDuplicateDialog"
      :close-button="true"
      persistent
      @closeButton="closeDuplicateModal"
    >
      <template slot="content">
        <p class="f-1 mb-0">
          {{ $t('alikes_families.p_e.duplicate_modal.text') }}
        </p>
      </template>
      <template slot="actions">
        <v-layout
          align-center
          class="my-2"
          justify-end
        >
          <a
            class="mr-3"
            @click="closeDuplicateModal()"
          >{{ $t('buttons.cancel') }}</a>
          <v-btn
            color="sz_violet"
            :disabled="checkPreviousEditionsLoader"
            :loading="checkPreviousEditionsLoader"
            @click="connectFamilyDuplicate"
          >
            {{ $t('buttons.connect') }}
          </v-btn>
        </v-layout>
      </template>
    </AppModal>
    <SimilarFamiliesPreviousEdition
      v-model="previousEditionModel"
      :loading="checkPreviousEditionsLoader"
      @close="previousEditionModel = false"
      @addNewFamily="leaveFamily"
      @forDecision="leaveToDecision"
      @overwriteFamily="connectFamily"
    />
  </v-layout>
</template>

<script>
import SimilarFamiliesPreviousEdition from '@/components/widgets/addFamily/SimilarFamiliesPreviousEdition';
import httpStatusCode from 'http-status-codes';
import AppModal from '@/components/widgets/AppModal.vue';

export default {
    name: 'CheckPreviousEditionsButton',
    components: { SimilarFamiliesPreviousEdition, AppModal },
    props: {
        visible: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        httpStatusCode,
        isGluedModal: false,
        previousEditionModel: false,
        checkPreviousEditionsLoader: null,
        responseNoContent: null,
        responseModal: false,
        showDuplicateDialog: false,
        duplicateGlued: false
    }),
    computed: {
        similarityParameters () {
            return this.$store.getters['familyData/getSimilarityParameters']
                ? this.$store.getters['familyData/getSimilarityParameters']
                : {
                    chosenOption: null,
                    chosenFamily: null
                };
        },
        similarFamilyModalText () {
            if (this.responseNoContent) {
                return this.$t('alikes_families.p_e.modal.no_content');
            }
            if (this.similarityParameters.chosenOption === 1) {
                return this.$t('alikes_families.p_e.modal.option_1_2');
            }
            if (this.similarityParameters.chosenOption === 2) {
                return this.$t('alikes_families.p_e.modal.option_2');
            }
            return '';
        },
        confirmButtonLoader () {
            return this.checkPreviousEditionsLoader && this.responseNoContent;
        }
    },
    methods: {
        closeResponseModal () {
            if (this.responseNoContent) {
                this.checkPreviousEditionsLoader = true;
                this.$store
                    .dispatch('familyData/markAsCheckedPreviousEditions', this.$route.params.id)
                    .then(({ data }) => {
                        this.$store.commit('family/setFamily', data.data);
                    })
                    .finally(() => {
                        this.responseModal = false;
                        this.responseNoContent = null;
                        this.checkPreviousEditionsLoader = false;
                    });
            } else {
                this.responseModal = false;
            }
        },
        closeGluedModal () {
            this.isGluedModal = false;
            if (this.duplicateGlued !== true) {
                this.responseModal = true;
            }
            this.duplicateGlued = false;
        },
        leaveFamily () {
            this.checkPreviousEditionsLoader = true;
            this.$store
                .dispatch('familyData/markAsCheckedPreviousEditions', this.$route.params.id)
                .then(({ data }) => {
                    this.$store.commit('family/setFamily', data.data);
                })
                .finally(() => {
                    this.checkPreviousEditionsLoader = false;
                    this.previousEditionModel = false;
                });
        },
        leaveToDecision () {
            this.previousEditionModel = false;
            this.responseModal = true;
        },
        connectFamily () {
            this.checkPreviousEditionsLoader = true;
            this.$store
                .dispatch('familyData/connectFamily', {
                    familyId: this.$route.params.id,
                    familyToConnectId: this.similarityParameters.chosenFamily
                })
                .then(({ data }) => {
                    this.$store.commit('family/setFamily', data.data);
                    this.isGluedModal = !!data.data.is_glued;
                })
                .finally(() => {
                    this.checkPreviousEditionsLoader = false;
                    this.previousEditionModel = false;
                    this.responseModal = !this.isGluedModal;
                });
        },
        checkFamilyPreviousEditions () {
            this.$store
                .dispatch('familyData/checkPreviousEditions', this.$route.params.id)
                .then(({ data }) => {
                    this.$store.commit('familyData/assignFamilyData', this.$store.getters['family/getFamily']);
                    this.$store.commit('familyData/setSimilarFamilies', data);
                    this.$store.dispatch('familyData/formatSimilarFamilies', data);
                    this.previousEditionModel = true;
                })
                .catch((e) => {
                    this.responseNoContent = e.response.status === 404;
                    if (this.responseNoContent) {
                        this.responseModal = true;
                    }
                })
                .finally(() => {
                    this.checkPreviousEditionsLoader = false;
                });
        },
        checkDuplicateInPreviousEdition () {
            if (this.checkPreviousEditionsLoader === true) {
                return;
            }
            this.checkPreviousEditionsLoader = true;

            this.$store
                .dispatch('familyData/checkDuplicateInPreviousEdition', this.$route.params.id)
                .then((response) => {
                    this.showDuplicateDialog = true;
                    this.checkPreviousEditionsLoader = false;
                })
                .catch((e) => {
                    const status = e.response && e.response.status;
                    if (status === this.httpStatusCode.NOT_FOUND) {
                        this.checkFamilyPreviousEditions();
                    } else {
                        this.checkPreviousEditionsLoader = false;
                    }
                });
        },
        closeDuplicateModal () {
            if (this.checkPreviousEditionsLoader === true) {
                return;
            }
            this.showDuplicateDialog = false;
        },
        connectFamilyDuplicate () {
            this.checkPreviousEditionsLoader = true;
            this.$store
                .dispatch('familyData/connectFamilyDuplicate', {
                    familyId: this.$route.params.id
                })
                .then(({ data }) => {
                    this.isGluedModal = !!data.data.is_glued;
                    this.duplicateGlued = this.isGluedModal;
                    this.$store.commit('family/setFamily', data.data);
                })
                .finally(() => {
                    this.checkPreviousEditionsLoader = false;
                    this.closeDuplicateModal();
                });
        }
    }
};
</script>

<style scoped></style>
